import React, { useEffect, useState, Fragment } from 'react'
import { connect } from 'react-redux'
import { Collapse } from '@material-ui/core'
import { Checkbox, Icon } from 'semantic-ui-react'
import { Cont, SContDetail } from './styled'
import { StdCard } from 'components'
import { DataCell } from '../DataCell'
import { getPrSpecialOptions } from 'ducks/options'
import { purchaseOrderDetailPath } from 'routes'
import { AdditionalRemark } from '../../AttributeData'
import * as v from 'variables/styles'
// import r from 'reactotron-react-js'

const PRGeneral = (props) => {
  const { prData, prLoading } = props

  const [showAdditional, setShowAdditional] = useState(prData.isAdditional)
  const [showSpecialPR, setShowSpecialPR] = useState(prData.special)
  const [showAffiliatedCompaniesPR, setShowAffiliatedCompaniesPR] = useState(prData.isAffiliatedCompanies)
  const [showPartnersPreQualifiedPR, setShowPartnersPreQualifiedPR] = useState(prData.isPartnersPreQualified)

  useEffect(()=>{
    if(prData.special){
      props.getPrSpecialOptions('Special')
    }else if(prData.isAffiliatedCompanies){
      props.getPrSpecialOptions('AffiliatedCompanies')
    }else if (prData.isPartnersPreQualified){
      props.getPrSpecialOptions('PartnersPreQualified')
    }
  },[prData.special, prData.isAffiliatedCompanies, prData.isPartnersPreQualified])

  const getSpecialReasonOption = (specialReason) => {
    return props.prSpecial.data.find(x => x.value === (specialReason || ''))
  }

  const getReasonTitle = (reasonCode) => {
    const reason = getSpecialReasonOption(reasonCode)
    return (reason || {}).text || ''
  }

  const getSubReasonTitle = (subReasonCode) => {
    const reason = getSpecialReasonOption(prData.specialReason)
    const subReasons = (reason || {}).subOptions || []
    const subReason = subReasons.find(x => x.value === (subReasonCode || prData.subSpecialReason || ''))
    return (subReason || {}).text || ''
  }

  return (
    <StdCard title='General Information' style={{ width: '100%', marginTop: '1rem' }} enableCollapse>
      <div style={{ display: 'flex' }}>
        <Cont>
          <SContDetail>
            <DataCell title='Ref SAP No.' value={!prLoading && prData.sapNumber} />
            <div />
          </SContDetail>
          <SContDetail>
            <DataCell title='PR Type' value={!prLoading && prData.type} />
            <div />
          </SContDetail>
          <SContDetail>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox label={{ children: 'Special PR' }} checked={!prLoading && prData.special} />
              <div style={{ width: '1rem' }} />
              <Icon name={`${showSpecialPR ? 'angle double up' : 'angle double down'}`} link circular onClick={() => setShowSpecialPR(!showSpecialPR)} />
            </div>
            <div />
          </SContDetail>
          <Collapse in={showSpecialPR}>
            {
              ((prData.specialReason || '').startsWith('SP') && (prData.specialReason || '').length === 4) ?
                <Fragment>
                  <SContDetail>
                    <DataCell title='Special PR Reason' value={!prLoading && getReasonTitle(prData.specialReason)} />
                  </SContDetail>
                  {
                    prData.specialReason === 'SP04' ? 
                      <SContDetail style={{ marginTop: '5px' }}>
                        <DataCell title='' value={!prLoading && getSubReasonTitle(prData.subSpecialReason)} />
                      </SContDetail> : null
                  }
                </Fragment> :
                <Fragment>
                  <SContDetail>
                    <DataCell title='Special PR Title' value={!prLoading && prData.specialTitle} />
                  </SContDetail>
                  <SContDetail>
                    <DataCell title='Special PR Reason' value={!prLoading && prData.specialReason} isAreaText />
                  </SContDetail>
                </Fragment>
            }
            <SContDetail>
              <DataCell title='Vendor' value={!prLoading && prData.special && prData.vendorName ? `${prData.vendorCode} || ${prData.vendorName}` : ''} />
            </SContDetail>
          </Collapse>
          <SContDetail>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox label={{ children: 'Affiliated Companies' }} checked={!prLoading && prData.isAffiliatedCompanies} />
              <div style={{ width: '1rem' }} />
              <Icon name={`${showAffiliatedCompaniesPR ? 'angle double up' : 'angle double down'}`} link circular onClick={() => setShowAffiliatedCompaniesPR(!showAffiliatedCompaniesPR)} />
            </div>
            <div />
          </SContDetail>
          <Collapse in={showAffiliatedCompaniesPR}>
            <SContDetail>
              <DataCell title='Affiliated Companies Reason' value={!prLoading && getReasonTitle(prData.affiliatedCompaniesReason)} />
            </SContDetail>
            <SContDetail>
              <DataCell title='Vendor' value={!prLoading && prData.isAffiliatedCompanies && prData.vendorName ? `${prData.vendorCode} || ${prData.vendorName}` : ''} />
            </SContDetail>
          </Collapse>
          <SContDetail>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox label={{ children: 'Partners(Pre-Qualified)' }} checked={!prLoading && prData.isPartnersPreQualified} />
              <div style={{ width: '1rem' }} />
              <Icon name={`${showPartnersPreQualifiedPR ? 'angle double up' : 'angle double down'}`} link circular onClick={() => setShowPartnersPreQualifiedPR(!showPartnersPreQualifiedPR)} />
            </div>
            <div />
          </SContDetail>
          <Collapse in={showPartnersPreQualifiedPR}>
            <SContDetail>
              <DataCell title='Partners(Pre-Qualified) Reason' value={!prLoading && getReasonTitle(prData.partnersPreQualifiedReason)} />
            </SContDetail>
            <SContDetail>
              <DataCell title='Vendor' value={!prLoading && prData.isPartnersPreQualified && prData.vendorName ? `${prData.vendorCode} || ${prData.vendorName}` : ''} />
            </SContDetail>
          </Collapse>
          <SContDetail>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox label={{ children: 'Additional PR' }} checked={!prLoading && prData.isAdditional} />
              <div style={{ width: '1rem' }} />
              <Icon name={`${showAdditional ? 'angle double up' : 'angle double down'}`} link circular onClick={() => setShowAdditional(!showAdditional)} />
            </div>
            <div />
          </SContDetail>
          <Collapse in={showAdditional}>
            {AdditionalRemark()}
            <SContDetail>
              <DataCell title='Additional Detail' value={!prLoading && prData.additionalReason} isAreaText />
            </SContDetail>
            <SContDetail>
              <DataCell title='Reference SAP PO (Original) No' value={!prLoading && prData.referencePoNo} />
              <DataCell title='Reference Contract No' value={!prLoading && prData.referenceContractNo} />
            </SContDetail>
            {
              prData.isAdditional && prData.referencePoId ?
                <div className='rowFields'>
                  <a 
                    href={purchaseOrderDetailPath(prData.referencePoId)} 
                    target='_blank'
                    style={{
                      color: v.ezMainColor,
                      fontWeight: 'bold',
                      textDecoration: 'underline'
                    }}
                  >PO Detail</a>
                </div> : null
            }
          </Collapse>
          {!prLoading && prData.rentDays &&
            <SContDetail>
              <DataCell title='Rent (days)' value={!prLoading && prData.rentDays} />
              <div />
            </SContDetail>}
        </Cont>
      </div>
    </StdCard>
  )
}

const mapStateToProps = (state) => ({
  prData: state.pr.prDetail.data || {},
  prLoading: state.pr.prLoading,
  prSpecial: state.options.prSpecial,
})

const mapDispatchToProps = {
  getPrSpecialOptions
}

export default connect(mapStateToProps, mapDispatchToProps)(PRGeneral)
